import { useParams } from "react-router-dom";
import { useReportDetails } from "./useReportDetails";
import { useFacilityDetails } from "./useFacilityDetails";
import { GetTierIiReportQuery } from "generated-graphql/graphql";

type RequireFields<T, K extends keyof T> = Required<Pick<T, K>> &
  Partial<Omit<T, K>>;

type PartialTierIIReport = RequireFields<
  GetTierIiReportQuery["tierIIReport"],
  "facility" | "tenantId"
> & {
  reasonForReport?: string | null;
};

type FulfillmentDetailsData = {
  tierIIReport: PartialTierIIReport;
};

export function useFulfillmentDetails() {
  const { reportId, facilityId } = useParams<{
    reportId?: string;
    facilityId?: string;
  }>();

  // existing hooks already handle the skip logic internally
  const reportQuery = useReportDetails();
  const facilityQuery = useFacilityDetails();

  const isUsingReport = !!reportId;
  const isUsingFacility = !!facilityId && !reportId;
  const activeQuery = isUsingReport ? reportQuery : facilityQuery;

  let data: FulfillmentDetailsData | undefined;

  if (isUsingReport && reportQuery.data) {
    data = reportQuery.data;
  } else if (isUsingFacility && facilityQuery.data?.facility) {
    data = {
      tierIIReport: {
        facility: facilityQuery.data.facility,
        tenantId: facilityQuery.data.facility.tenantId!,
      },
    };
  }

  return {
    data,
    loading: activeQuery.loading,

    isUsingReport,
    isUsingFacility,
    reportId: isUsingReport
      ? reportQuery.data?.tierIIReport?.id
      : facilityQuery.data?.tierIIReports?.items?.find(
          (item: { facilityId: string }) =>
            item && item.facilityId === facilityId
        )?.id,
  };
}
